import React, { PureComponent } from 'react';

import { Select, Radio } from 'antd';
import { thisExpression } from '@babel/types';

const {Option} = Select;

const AWS = ['us-east-1', 'us-east-2', 'us-west-1', 'us-west-2', 'eu-west-3', 'eu-west-1', 'eu-west-2', 'eu-central-1', 'ap-south-1', 'ap-southeast-1', 'ap-southeast-2', 'ap-northeast-1', 'ap-northeast-2', 'sa-east-1', 'ca-central-1'];
const Azure = ['eastasia', 'southeastasia', 'centralus', 'eastus', 'eastus2', 'westus', 'northcentralus', 'southcentralus', 'northeurope', 'westeurope', 'japanwest', 'japaneast', 'brazilsouth', 'australiaeast', 'australiasoutheast', 'southindia', 'centralindia', 'westindia', 'canadacentral', 'canadaeast', 'uksouth', 'ukwest', 'westcentralus', 'westus2', 'koreacentral', 'koreasouth'
];
// function handleChange(value) {
//   
//   
// }

class EditRegionSelector extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedItems: [],
    };
  }


  componentDidMount() {
    let selectedRegions = this.props.region;

    this.props.selectregion(selectedRegions);
  }

  handleChange = selectedItems => {

    this.setState({ selectedItems });
  };
  handleChange = e => {


    this.props.selectregion(e);

    // 
  };

  render() {
    const { size } = this.state;
    const { region } = this.props

    const { selectedItems } = this.state;
    if (this.props.provider === 'AWS') {
      var filteredOptions = AWS.filter(o => !selectedItems.includes(o));


    } else {
      var filteredOptions = Azure.filter(o => !selectedItems.includes(o));

    }
    if (region.length > 0) {
      var selectedRegions = region;
    } else {
    }
    return (
      <div>
        <Select
          mode="tags"
          placeholder="Please Select A Region"
          // value={selectedItems}
          defaultValue={selectedRegions}
          onChange={this.handleChange}
          // style={{ width: 360 }}
        >
          {filteredOptions.map(item => (
            <Select.Option key={item} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>

      </div>
    );
  }
}
export default EditRegionSelector;
